import { render, staticRenderFns } from "./TiptapOutput.vue?vue&type=template&id=23bfb206&scoped=true"
import script from "./TiptapOutput.vue?vue&type=script&lang=js"
export * from "./TiptapOutput.vue?vue&type=script&lang=js"
import style0 from "./TiptapOutput.vue?vue&type=style&index=0&id=23bfb206&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23bfb206",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UIEditorTextEditor: require('/opt/atlassian/pipelines/agent/build/components/UI/Editor/TextEditor.vue').default})
